module.exports = __webpack_public_path__ + "img/yvonne-harris.3a152da8.jpg";